"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentPropertyIds = exports.getAnalyticActions = exports.getCurrentPage = exports.getGlobalTranslation = exports.getIsLanguageItem = exports.getIsCurrencyItem = exports.getAvailableLanguages = exports.getReturnState = exports.getMenuItems = exports.getMenuItemIndex = exports.getCurrentFavCount = exports.getMenuItemField = exports.getActivePanelField = void 0;
var Pages_1 = require("@/rendering/common/Pages");
var getActivePanelField = function (it) { return it.layout.activePanel; };
exports.getActivePanelField = getActivePanelField;
var getMenuItemField = function (it, index) {
    return it.layout.menulist[index].opened;
};
exports.getMenuItemField = getMenuItemField;
var getCurrentFavCount = function (state) {
    return state.sfav ? state.sfav.sectionFav.items.length +
        state.sfav.sectionFavInt.items.length : 0;
};
exports.getCurrentFavCount = getCurrentFavCount;
var getMenuItemIndex = function (state, item) {
    return state.layout.menulist.indexOf(item);
};
exports.getMenuItemIndex = getMenuItemIndex;
var getMenuItems = function (state) { return state.layout.menulist; };
exports.getMenuItems = getMenuItems;
var getReturnState = function (state) { return state.layout.returnState; };
exports.getReturnState = getReturnState;
var getAvailableLanguages = function (state) { return state.layout.language.languages; };
exports.getAvailableLanguages = getAvailableLanguages;
var getIsCurrencyItem = function (state, item) {
    return state.layout.currencies.options.filter(function (it) { return it.code === item.name; }).length > 0;
};
exports.getIsCurrencyItem = getIsCurrencyItem;
var getIsLanguageItem = function (state, item) {
    return state.layout.language.languages.filter(function (it) { return it.shortName === item.name; }).length > 0;
};
exports.getIsLanguageItem = getIsLanguageItem;
var getGlobalTranslation = function (state) { return state.translate; };
exports.getGlobalTranslation = getGlobalTranslation;
var getCurrentPage = function (state) { return state.page; };
exports.getCurrentPage = getCurrentPage;
var getAnalyticActions = function (state) { return state.analyticActions || null; };
exports.getAnalyticActions = getAnalyticActions;
var getCurrentPropertyIds = function (state) {
    if (state.page === Pages_1.Pages.SEARCH) {
        var searchpageState = state;
        return searchpageState.results.resultResponses.length ?
            searchpageState.results.resultResponses[searchpageState.results.resultResponses.length - 1]
                .results.map(function (it) { return Number(it.referenceId); }) : [];
    }
    return [];
};
exports.getCurrentPropertyIds = getCurrentPropertyIds;
